import type {
  ColDef,
  GridApi,
  IServerSideGetRowsParams,
} from 'ag-grid-enterprise';
import { columnOperations } from '../columns/columnOperations';
import { mapFilterModelToSubquery } from '../filters/mapFilterModelToSubquery';
import type { FilterModel } from '../filters/types';
import { INVENTORY_PAGE_SIZE } from '../inventoryConsts';
import type { ReferenceInventoryColDef } from './referenceInventoryColumns';
import type {
  NextReferenceRowsBatchParams,
  ReferenceInventoryRow,
  RequestedReferenceColumn,
} from './types';

const isReferenceInventoryColDef = (
  colDef: ColDef<ReferenceInventoryRow>
): colDef is ReferenceInventoryColDef =>
  colDef.context?.requestedColumn !== undefined;

const getDisplayedReferenceColumns = (
  gridApi: GridApi<ReferenceInventoryRow>
): RequestedReferenceColumn[] =>
  gridApi
    .getAllDisplayedColumns()
    .map(column => column.getColDef())
    .filter(isReferenceInventoryColDef)
    .map(({ context }) => context.requestedColumn);

export const mapAgGridParamsToReferenceBatchParams = ({
  request: { startRow, endRow, filterModel },
  api,
}: IServerSideGetRowsParams<ReferenceInventoryRow>): NextReferenceRowsBatchParams => ({
  from: startRow ?? 0,
  size: (endRow ?? INVENTORY_PAGE_SIZE) - (startRow ?? 0),
  columns: getDisplayedReferenceColumns(api),
  subquery: mapFilterModelToSubquery(
    (filterModel ?? {}) as FilterModel,
    columnOperations.toLeafColumnDefs(api.getColumnDefs() ?? [])
  ),
});
